import React from 'react';
import Navbar from '../gral-components/Navbar';
import Header from '../gral-components/Header';
import BorderCurved from '../gral-components/BorderCurved';
import Subtitles from '../gral-components/Subtitles.js';
import Template from '../gral-components/Template';
import Testimonials from '../gral-components/Testimonials';
import BlogBox from '../gral-components/BlogBox';
import Trusted from '../gral-components/trusted';
import Footer from '../gral-components/Footer';
import '../gral-stylesheets/home.scss';

import dataDearHR from '../data/dearHR/unauthenticated.json';



class Unauthenticated extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      join: false,
      success: false,
      passwordReset: false,
    }
  }

  componentDidMount() {
    this.animationHandle();
  }

  animationHandle = () => {
    let animation1 = document.getElementById('header-unauthenticated-animation');
    let animation2 = document.getElementById('talent-animation');
    let animation3 = document.getElementById('job-animation');
    let animation4 = document.getElementById('about-us-animation');
    let animation5 = document.getElementById('testimonials-animation');
    let animation6 = document.getElementById('blog-animation');
    let animation7 = document.getElementById('trusted-animation');

    let animation = (entradas) => {
      entradas.forEach((entrada) => {
        if (entrada.isIntersecting) {
          switch (entrada.target.className) {
            case 'header-unauthenticated-animation':
              entrada.target.classList.add('visible');
              break;
            case 'talent-animation':
              entrada.target.classList.add('visible');
              break;
            case 'job-animation':
              entrada.target.classList.add('visible');
              break;
            case 'about-us-animation':
              entrada.target.classList.add('visible');
              break;
            case 'testimonials-animation':
              entrada.target.classList.add('visible');
              break;
            case 'blog-animation':
              entrada.target.classList.add('visible');
              break;
            case 'trusted-animation':
              entrada.target.classList.add('visible');
              break;
            default:
              break;
          }
        }
      });
    }

    let observer = new IntersectionObserver(animation, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    });

    observer.observe(animation1);
    observer.observe(animation2);
    observer.observe(animation3);
    observer.observe(animation4);
    observer.observe(animation5);
    observer.observe(animation6);
    observer.observe(animation7);
  }

  render() {
    return (
      <div className='background-gradient-image'>
        <div
          id='header-home'
          className='header-unauthenticated'
        >
          <Navbar
            aboutUs={true}
            testimonials={true}
            blog={true}
            navbarType='unauthenticated'
            loginOpenHandle={this.props.loginOpenHandle}
            joinOpenHandle={this.props.joinOpenHandle}
          />
          <section
            id='header'
            className='header-section'
          >
            <Header
              headerType='unauthenticated'
              joinState={this.state.join}
              toLogin={this.joinToLogin}
              images={''}
              textWriter={dataDearHR.textWriter.visitor}
              joinOpenHandle={this.props.joinOpenHandle}
            />
          </section>
        </div>
        <div className='main-content'>
          <div className='border-curved-top-container'>
            <BorderCurved
              transform={false}
              background={{
                backgroundImage: 'none'
              }}
              fill='whitesmoke'
            />
          </div>
          <section
            id='talent'
            className='seekers-section background-dark'
          >
            <div
              id='talent-animation'
              className='talent-animation'
            >
              <Template
                darkText={true}
                xDirectionNormal={false}
                titleSmall='Where you can'
                titleBig='Look for talents'
                description={dataDearHR.seekers.description}
                textButton='Search talents'
                image={dataDearHR.seekers.image}
                joinOpenHandle={this.props.joinOpenHandle}
              />
            </div>
          </section>
          <section
            id='job'
            className='talent-section background-clear'
          >
            <div
              id='job-animation'
              className='job-animation'
            >
              <Template
                darkText={true}
                xDirectionNormal={true}
                titleSmall='Where'
                titleBig='The job finds talent'
                description={dataDearHR.talent.description}
                textButton='Search job'
                image={dataDearHR.talent.image}
                joinOpenHandle={this.props.joinOpenHandle}
              />
            </div>
          </section>

          <section
            id='about-us'
            className='about-us-section'
          >
            <div
              id='about-us-animation'
              className='about-us-animation'
            >
              <Template
                darkText={false}
                templateType='about-us'
                xDirectionNormal={false}
                titleSmall='What We Are'
                titleBig='About Us'
                description={dataDearHR.aboutUs.description}
                image={false}
              />
            </div>
          </section>

          <section
            id='testimonials'
            className='testimonials-section background-clear'
          >
            <div
              id='testimonials-animation'
              className='testimonials-animation'
            >
              <div className='subtitles-container'>
                <Subtitles
                  darkText={true}
                  titleSmall='Happy Clients'
                  titleBig='Testimonials'
                />
              </div>
              <Testimonials
                isDarkBackground={false}
              />
            </div>
          </section>
          <section
            id='blog'
            className='blog-section background-dark'
          >
            <div
              id='blog-animation'
              className='blog-animation'
            >
              <div className='subtitles-container'>
                <Subtitles
                  darkText={true}
                  titleSmall='Our Blog'
                  titleBig='Recent post'
                />
              </div>
              <BlogBox
                isDarkBackground={false}
              />
            </div>
          </section>
          <section
            id='trusted'
            className='trusted-section background-clear'
          >
            <div
              id='trusted-animation'
              className='trusted-animation'
            >
              <Trusted
              />
            </div>
          </section>
          <div className='border-curved-bottom-container'>
            <BorderCurved
              transform={true}
              background={{
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }}
              fill='white'
            />
          </div>
        </div>
        <section
          id='footer'
          className='footer-section' >
          <Footer
            footerMini={false}
          />
        </section>
      </div>
    );
  }

};

export default Unauthenticated;
